module.exports = __webpack_public_path__ + "img/banner14-2@2x.717b0599.jpg";